"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConditions = exports.isCondition = void 0;
var isCondition = function (value) {
    return value.hasOwnProperty("field") &&
        value.hasOwnProperty("value") &&
        value.hasOwnProperty("compare");
};
exports.isCondition = isCondition;
var isConditions = function (value) {
    return value.hasOwnProperty("relation") &&
        value.hasOwnProperty("entries");
};
exports.isConditions = isConditions;
